import { render } from "./ColumnMapping.vue?vue&type=template&id=2c4325ec"
import script from "./ColumnMapping.vue?vue&type=script&lang=js"
export * from "./ColumnMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/ColumnMapping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c4325ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c4325ec', __exports__)) {
    api.reload('2c4325ec', __exports__)
  }
  
  module.hot.accept("./ColumnMapping.vue?vue&type=template&id=2c4325ec", () => {
    api.rerender('2c4325ec', render)
  })

}


export default __exports__